// extracted by mini-css-extract-plugin
export var blackSection = "NavMenu-module--blackSection--33d3b";
export var blackSectionLinks = "NavMenu-module--blackSectionLinks--e4fbb";
export var blackSectionTablet = "NavMenu-module--blackSectionTablet--e5670";
export var footer = "NavMenu-module--footer--93e6b";
export var horizontalSpacer = "NavMenu-module--horizontalSpacer--ad7ee";
export var icon = "NavMenu-module--icon--731ce";
export var logoWhite = "NavMenu-module--logoWhite--6df81";
export var navContainer = "NavMenu-module--navContainer--2e70c";
export var navContainerTablet = "NavMenu-module--navContainerTablet--ce775";
export var navMenuPrimary = "NavMenu-module--navMenuPrimary--ed271";
export var navMenuSecondary = "NavMenu-module--navMenuSecondary--88a41";
export var navMenuTertiary = "NavMenu-module--navMenuTertiary--7b7a3";
export var navSlider = "NavMenu-module--navSlider--579d1";
export var navSliderTablet = "NavMenu-module--navSliderTablet--e4f90";
export var secondaryImage = "NavMenu-module--secondaryImage--5f37d";
export var secondarySection = "NavMenu-module--secondarySection--eebfb";
export var secondarySectionText = "NavMenu-module--secondarySectionText--469d0";
export var tertiaryHeadingImage = "NavMenu-module--tertiaryHeadingImage--70ce0";
export var tertiaryItemImage = "NavMenu-module--tertiaryItemImage--e9f0a";
export var tertiaryItemLabel = "NavMenu-module--tertiaryItemLabel--ee907";
export var tertiarySection = "NavMenu-module--tertiarySection--97217";
export var tertiarySectionItem = "NavMenu-module--tertiarySectionItem--a1b30";
export var verticalSpacer = "NavMenu-module--verticalSpacer--33eda";
export var whiteSection = "NavMenu-module--whiteSection--a7c73";